import { render, staticRenderFns } from "./chart-gantt.vue?vue&type=template&id=64020918&"
import script from "./chart-gantt.vue?vue&type=script&lang=ts&"
export * from "./chart-gantt.vue?vue&type=script&lang=ts&"
import style0 from "./chart-gantt.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports